export default "__VITE_ASSET__hbGyvsj1__"